import { useContext } from 'react';
import { FormContext } from '../context';
import { HOOK_MARK } from '../constants';
// eslint-disable-next-line no-redeclare
function useWatch(names, form) {
    const { form: contextForm } = useContext(FormContext);
    const internalForm = form ?? contextForm;
    if (!internalForm) {
        console.warn('Warning: useWatch requires a form instance since it can not auto detect from context.');
        return typeof names === 'string' ? null : [];
    }
    const { watch, rhfForm: { formState: { defaultValues }, }, } = internalForm._getInternalHooks(HOOK_MARK);
    if (Array.isArray(names)) {
        return watch(names, defaultValues);
    }
    return watch(names);
}
export default useWatch;
